import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { ClinicalAdminState } from '@store/clinical-admin-summary/clinical-admin-summary.state';
import { withNgxsReduxDevtoolsPlugin } from '@ngxs/devtools-plugin';
import { withNgxsRouterPlugin } from '@ngxs/router-plugin';
import { provideStates, provideStore } from '@ngxs/store';
import { AuthState } from '@store/auth/auth.state';
import { EmployeeState } from '@store/employees/employee.state';
import { StationState } from '@store/stations/station.state';
import { PatientState } from '@store/patient/patient.state';
import { ConsultationState } from '@store/consultations/consultation.state';
import { AvailableCareAdminsState } from '@store/available-care-admins/available-care-admins.state';
import { InProgressConsultationState } from '@store/in-progress-consultation/in-progress-consultation.state';
import { TransferConsultationState } from '@store/transfer-consultation/transfer-consultation.state';
import { routes } from './app.routes';
import { TokenInterceptor } from './core/token.interceptor';
import { AppState } from '@store/app/app.state';
import { provideLottieOptions } from 'ngx-lottie';
import { ConsultationClinicalAdminState } from '@store/consultation/consultation.state';
import { IncomingCallsState } from '@store/incoming-calls/incoming-calls.state';
import { withNgxsStoragePlugin } from '@ngxs/storage-plugin';

const STATES = [
  StationState,
  AuthState,
  EmployeeState,
  ClinicalAdminState,
  AvailableCareAdminsState,
  ConsultationState,
  ConsultationClinicalAdminState,
  InProgressConsultationState,
  TransferConsultationState,
  PatientState,
  IncomingCallsState,
  AppState,
];
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimationsAsync(),
    provideRouter(routes),
    provideHttpClient(), //
    provideStore(),
    provideStates(STATES),
    withNgxsRouterPlugin(),
    withNgxsReduxDevtoolsPlugin(),
    provideAnimationsAsync(),
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    withNgxsStoragePlugin({
      keys: ['patient', 'consultation']
    })
  ],
};
